import { useState, useEffect } from 'react';

export type imgResolution = 'default' | 'mqdefault' | 'hqdefault' | 'sddefault' | 'maxresdefault';

const expectedWidths: Record<imgResolution, number> = {
  default: 120,
  mqdefault: 320,
  hqdefault: 480,
  sddefault: 640,
  maxresdefault: 1280,
};

interface UseYoutubeThumbnailProps {
  videoId: string;
  vi?: string;
  format?: string;
  imageRes?: imgResolution;
  enabled?: boolean;
}

export const useYoutubeThumbnail = ({
  videoId,
  vi = 'vi_webp',
  format = 'webp',
  imageRes = 'sddefault',
  enabled = true,
}: UseYoutubeThumbnailProps) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const testUrl = `https://img.youtube.com/${vi}/${videoId}/${imageRes}.${format}`;
    const fallbackUrl = `https://img.youtube.com/${vi}/${videoId}/hqdefault.${format}`;

    const expectedWidth = expectedWidths[imageRes];

    const img = new Image();
    img.onload = () => {
      if (img.width < expectedWidth) {
        setUrl(fallbackUrl);
      } else {
        setUrl(testUrl);
      }
    };
    img.onerror = () => setUrl(fallbackUrl);
    img.src = testUrl;
  }, [videoId, vi, format, imageRes, enabled]);

  return url;
};

export default useYoutubeThumbnail;
